module.exports = __webpack_public_path__ + "img/talisman.1c0fe4f2.svg";